import React, { createContext, useContext, useState } from 'react';

const ProfileSetupContext = createContext(null);

export function ProfileSetupProvider({ children }) {
  const [data, setData] = useState({
    full_name: '',
    dob: '',
    gender: '',
    denomination: '',
    faith_level: 0,
    home_church: '',
    bio: '',
    interests: [],
    photos: [], // already uploaded photos: { id, url, position }
  });

  const updateData = (updates) => {
    setData((prev) => ({ ...prev, ...updates }));
  };

  return (
    <ProfileSetupContext.Provider value={{ data, updateData }}>
      {children}
    </ProfileSetupContext.Provider>
  );
}

export function useProfileSetup() {
  const ctx = useContext(ProfileSetupContext);
  if (!ctx) throw new Error('useProfileSetup must be used within ProfileSetupProvider');
  return ctx;
}